// extracted by mini-css-extract-plugin
export default {"pagination":"SuperPagination_pagination__VAhMq","text1":"SuperPagination_text1__VBVHe","text2":"SuperPagination_text2__HKaB2"};